import r from "./_getLength.js";
import t from "./isArray.js";
import m from "./isString.js";
import o from "./isArguments.js";
import i from "./keys.js";
function s(s) {
  if (null == s) return !0;
  var e = r(s);
  return "number" == typeof e && (t(s) || m(s) || o(s)) ? 0 === e : 0 === r(i(s));
}
export { s as default };